import { createRouter, createWebHistory } from "vue-router"
import {storeToRefs} from "pinia";

import HomePage from '../pages/home/HomePage'
import RubricPage from '../pages/rubric/RubricPage'
import ArticlePage from '../pages/article/ArticlePage'
import FilteredArticlesPage from '../pages/filteredArticle/FilteredArticlesPage'
import ErrorPage from '../pages/error/ErrorPage'

import {useClientStorage, useRubricArticleStore, useStatesStorage} from "@/stores/store";
import AdminPage from "@/pages/admin/AdminPage";
import {
    ADMIN_USER_ROLE,
    CONST_RUBRIC_PATH,
    CONST_ARTICLE_PATH,
    CONST_FILTERED_ARTICLES_PATH,
    CONST_ERROR_PAGE_PATH,
    CONST_HOME_PATH,
    CONST_ADMIN_PATH
} from "@/shared/constants/consts";
import {initPage} from "@/shared/services/init";
import {validArticleRoute, validRubricRoute} from "@/router/services/validateRoute";
import {UpdateTitleAndMeta} from "@/shared/services/util";

const routes = [
    {
        path: CONST_HOME_PATH,
        name: 'home',
        component: HomePage,
        beforeEnter(to, from) {
            return new Promise((resolve) => {
                initPage(to, from)
                    .then(r => {
                        const rubricArticleStore = useRubricArticleStore();
                        rubricArticleStore.updateRouteQuery(null, null);

                        UpdateTitleAndMeta(to);

                        const resultInitView = r.resultInitView;

                        resolve(resultInitView)
                    })
            })
        },
    },
    {
        path: CONST_RUBRIC_PATH,
        name: 'rubric',
        component: RubricPage,
        beforeEnter(to, from) {
            //console.log('to',to, from);

            const statesStorage = useStatesStorage();
            const { viewStates } = storeToRefs(statesStorage);

            if(!Object.prototype.hasOwnProperty.call(to.query, 'r')) {
                viewStates.value.show_preloader_spinner = false;
                return CONST_ERROR_PAGE_PATH;
            }

            const rubricArticleStore = useRubricArticleStore();

            rubricArticleStore.updateRouteQuery(to.query.r, null);

            return new Promise((resolve) => {
                initPage(to, from)
                    .then(r => {
                        const { rubrics } = storeToRefs(rubricArticleStore);

                        const valid_rubric_route = validRubricRoute(rubrics.value, to.query);

                        UpdateTitleAndMeta(to);

                        const resultInitView = r.resultInitView;

                        resolve(resultInitView && valid_rubric_route ? true : CONST_ERROR_PAGE_PATH)
                    })
            })
        },
    },
    {
        path: CONST_ARTICLE_PATH,
        name: 'article',
        component: ArticlePage,
        beforeEnter(to, from) {
            //console.log('to',to, from);

            const statesStorage = useStatesStorage();
            const { viewStates } = storeToRefs(statesStorage);


            if(!Object.prototype.hasOwnProperty.call(to.query, 'r') || !Object.prototype.hasOwnProperty.call(to.query, 'a')) {
                viewStates.value.show_preloader_spinner = false;
                return CONST_ERROR_PAGE_PATH;
            }
            const rubricArticleStore = useRubricArticleStore();

            rubricArticleStore.updateRouteQuery(to.query.r, to.query.a);

            return new Promise((resolve) => {
                initPage(to, from)
                    .then(r => {
                        const clientStorage = useClientStorage();
                        const lang = clientStorage.clientObj.lang;

                        const { articles } = storeToRefs(rubricArticleStore);
                        const valid_rubric_route = validArticleRoute(articles.value, to.query, lang);

                        UpdateTitleAndMeta(to);

                        const resultInitView = r.resultInitView;

                        resolve(resultInitView && valid_rubric_route ? true : CONST_ERROR_PAGE_PATH)
                    })
            })
        },
    },
    {
        path: CONST_FILTERED_ARTICLES_PATH,
        name: 'filtered-articles',
        component: FilteredArticlesPage,
        beforeEnter(to, from) {
            return new Promise((resolve) => {
                initPage(to, from)
                    .then(r => {
                        const rubricArticleStore = useRubricArticleStore();
                        rubricArticleStore.updateRouteQuery(null, null);

                        UpdateTitleAndMeta(to);

                        const resultInitView = r.resultInitView;

                        resolve(resultInitView)
                    })
            })
        }

    },
    {
        path: CONST_ADMIN_PATH,
        name: 'help-pbt-admin',
        component: AdminPage,
        beforeEnter(to, from) {
            return new Promise((resolve) => {
                initPage(to, from, true)
                    .then(r => {
                        const clientStorage = useClientStorage();
                        const role = clientStorage.clientObj.role;

                        UpdateTitleAndMeta(to);

                        const resultInitView = r.resultInitView;
                        resolve(resultInitView && role == ADMIN_USER_ROLE ? true : CONST_ERROR_PAGE_PATH);
                    })
            })
        },
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'error-page',
        component: ErrorPage
    },
]

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior() {
        return { top: 0, behavior: 'instant' }
    },
})

export default router;